/**
 * stripDealCode — Defensive sanitizer for any visitor-facing copy block on
 * a lead-capture surface (popup or inline form).
 *
 * Owners sometimes type the live deal code directly into popup body text
 * ("Use code WAIT15"), which leaks the gate before the visitor consents
 * to SMS. The owner editor surfaces a warning, but at the rendering layer
 * we strip the code defensively so existing leaky configs auto-clean.
 *
 * Strips: "use code <CODE>", "code: <CODE>", "promo code <CODE>",
 * "coupon code <CODE>", and the bare token. Trailing punctuation gets
 * tidied so the cleaned line still reads naturally.
 */
export function stripDealCode(text, code) {
  if (!text) return "";
  const c = (code || "").trim();
  if (!c || c.length < 3) return text;
  const codeRe = new RegExp(
    `\\b(use\\s+code\\s+|code\\s*[:=-]?\\s*|promo\\s+code\\s+|coupon\\s+code\\s+)?${c.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b[.!]?`,
    "gi"
  );
  return text
    .replace(codeRe, "")
    .replace(/\s{2,}/g, " ")
    .replace(/\s+([.!,])/g, "$1")
    .trim();
}

/** True when the visitor copy contains the live deal code. Used by the
 *  owner editor to surface a "your code is showing" warning. */
export function bodyContainsDealCode(text, code) {
  if (!text || !code || code.length < 3) return false;
  const re = new RegExp(`\\b${code.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`, "i");
  return re.test(text);
}
